import Reveal from "@/components/Reveal";

/**
 * EventTrailer — the official Chapter 2 advert / trailer.
 *
 * Used on the Chapter II page and the Press Release page. Renders
 * a 16:9 lazy-loaded YouTube embed inside the dark cinematic section
 * style with a short editorial intro line.
 */

const TRAILER_ID = "aWdQc4BjKG8";

export default function EventTrailer({
  eyebrow = "The Trailer",
  title = "Nick Fraser: Chapter 2 — the official advert.",
  body = "A cinematic introduction to the one-day exhibition at Shoreditch Arts Club. Paintings, projection, archive film and the first public release of limited-edition Nick Fraser prints.",
  testid = "event-trailer",
  variant = "dark", // "dark" | "bone"
}) {
  const isDark = variant === "dark";
  return (
    <section
      className={`${isDark ? "dark-section" : "bone-section"} py-24 md:py-40`}
      data-testid={testid}
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20 items-center">
        <Reveal className="md:col-span-5">
          <p className="hairline opacity-60 mb-6">{eyebrow}</p>
          <h2 className="font-serif italic text-4xl md:text-5xl leading-[1.05]">
            {title}
          </h2>
          <p className="font-serif italic text-lg md:text-xl opacity-80 mt-8 max-w-md leading-relaxed">
            {body}
          </p>
          <a
            href={`https://www.youtube.com/watch?v=${TRAILER_ID}`}
            target="_blank"
            rel="noreferrer"
            className="link-quiet font-serif italic text-lg md:text-xl mt-10 inline-block"
            data-testid={`${testid}-link`}
          >
            Watch on YouTube →
          </a>
        </Reveal>
        <Reveal className="md:col-span-7" slow>
          <div
            className="relative w-full overflow-hidden bg-black"
            style={{ aspectRatio: "16 / 9" }}
          >
            <iframe
              src={`https://www.youtube-nocookie.com/embed/${TRAILER_ID}?rel=0&modestbranding=1`}
              title="Nick Fraser: Chapter 2 — Official Trailer"
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute inset-0 w-full h-full"
              data-testid={`${testid}-iframe`}
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
